import { render, staticRenderFns } from "./DataViewSidebarQuestions.vue?vue&type=template&id=510a689d&scoped=true&"
import script from "./DataViewSidebarQuestions.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarQuestions.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarQuestions.vue?vue&type=style&index=0&id=510a689d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a689d",
  null
  
)

export default component.exports